var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1660 367h-682l-74-139 686-1c39 0 70 32 70 70zm-207 1041h-1200c-30 0-30-46 0-46h1200c31 0 31 46 0 46zm167 173h-1533c-48 0-87-39-87-87v-1224c0-80 65-144 144-144h692c21 0 29 28 43 55h711c64 0 117 52 117 116v1197c0 48-39 87-87 87zm-1573-1167v1080c0 22 18 40 40 40h1533c22 0 40-18 40-40v-1080zm0-47h878l-103-195h-678c-54 0-97 44-97 98zm155-29c-90 0-90-137 0-137s90 137 0 137zm0-90c-28 0-28 44 0 44 29 0 29-44 0-44zm170 90c-90 0-90-137 0-137 91 0 91 137 0 137zm0-90c-28 0-28 44 0 44 29 0 29-44 0-44zm171 90c-91 0-91-137 0-137 37 0 68 31 68 69 0 37-31 68-68 68zm0-90c-29 0-29 44 0 44 28 0 28-44 0-44zm-379 769v-383c0-52 42-94 94-94h1190c52 0 94 42 94 94v383c0 52-42 94-94 94h-1190c-52 0-94-41-94-94zm94-431c-26 0-47 22-47 48v383c0 16 7 29 19 38l315-316c48-47 125-47 172 0l136 137 137-137c47-47 124-47 171 0l316 316c11-9 19-22 19-38v-383c0-26-22-48-48-48zm28 479h378l156-156-136-136c-29-30-77-30-106 0zm444 0h690l-292-293c-29-29-76-29-105 0zm123-282c-44 0-80-36-80-81 0-44 36-81 80-81 45 0 81 37 81 81 0 45-36 81-81 81zm0-115c-44 0-44 68 0 68 45 0 45-68 0-68zm-403 97h-182c-31 0-31-47 0-47h182c31 0 31 47 0 47zm109-94h-182c-31 0-31-46 0-46h182c31 0 31 46 0 46zm885 85h-183c-30 0-30-47 0-47h183c30 0 30 47 0 47zm-162-77h-182c-31 0-31-47 0-47h182c31 0 31 47 0 47zm171 581h-1200c-30 0-30-47 0-47h1200c31 0 31 47 0 47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingpage);
export default __webpack_public_path__ + "static/media/landingpage.836fd1ccf88a012d23d15a2786787d61.svg";
export { ForwardRef as ReactComponent };